<template>
    <div class="viewport">
        <md-toolbar :md-elevation="1">
            <span class="md-title md-list-item-text primary">Klant</span>
            <md-button
                @click="showDialogSelectClient = true"
                class="md-icon-button md-list-action"
                v-if="!isExistingWorkOrder && selectedClient"
            >
                <md-icon>edit</md-icon>
            </md-button>
        </md-toolbar>
        <md-list class="md-double-line">
            <div style="width: 100%; display: flex" v-if="!selectedClient">
                <md-button class="md-primary" @click="showDialogSelectClient = true" style="flex: 1">
                    <md-icon>add</md-icon>
                    klant
                </md-button>
            </div>

            <md-list-item v-if="selectedClient">
                <client-card
                    :client="selectedClient"
                    :delivery-address="this.workOrder.data.address"
                    style="width: 100%"
                />
            </md-list-item>
        </md-list>
        <md-dialog style="z-index: 9" :md-active.sync="showDialogSelectClient">
            <md-dialog-title
                >Select Client
                <md-list>
                    <md-list-item>
                        <md-icon>face</md-icon>
                        <span class="md-list-item-text">Bestaande klant</span>
                    </md-list-item>
                </md-list>
            </md-dialog-title>

            <md-dialog-content>
                <md-list v-if="existingCustomer">
                    <md-list-item>
                        <client-search-modal
                            :clients-only="true"
                            @set-selected-client="setSelectedClient($event)"
                            @set-selected-delivery-address="setSelecetedDeliveryAddress($event)"
                            style="padding-left: 15px; z-index: 1000"
                        >
                        </client-search-modal>
                    </md-list-item>
                </md-list>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button @click="cancelSelectClient()" class="md-primary">Cancel</md-button>
                <md-button @click="addSelectClient()" class="md-primary">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IAddress, IClientEntity, Language } from '@phrospr/api-backend';
import ClientSearchModal from '@/components/client-search-modal/ClientSearchModal.vue';
import ClientCard from '@/components/client/ClientCard.vue';
import { IWorkOrderEntity } from '@phrospr/lib-models';
import { workOrderStore } from '@/store/work-order/workOrder.store';

@Component({
    components: { ClientCard, ClientSearchModal },
})
export default class WorkOrderClient extends Vue {
    @Prop() private workOrder: IWorkOrderEntity;

    existingCustomer = true;
    showDialogSelectClient = false;

    Language = Language;
    sending = false;

    get selectedClient() {
        return workOrderStore.state.selectedClient;
    }

    get selectedDeliveryAddress() {
        return workOrderStore.state.upsertWorkOrder.data.address;
    }

    get isExistingWorkOrder() {
        return this.workOrder.work_order_id !== null;
    }

    constructor() {
        super();
        this.load();
    }

    private async load() {}

    public async cancelSelectClient() {
        this.showDialogSelectClient = false;
    }

    public async addSelectClient() {
        this.workOrder.client_id = this.selectedClient.client_id;
        this.showDialogSelectClient = false;
    }

    setSelectedClient(client: IClientEntity) {
        workOrderStore.commit('setSelectedClient', client);
    }

    setSelecetedDeliveryAddress(address: IAddress) {
        workOrderStore.commit('setSelectedAddress', address);
    }

    reset() {
        workOrderStore.commit('setSelectedClient', null);
        this.workOrder.client_id = undefined;
    }
}
</script>

<style lang="scss" scoped></style>
